import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userObj } from "../../../../helper/protectedRoutes";
import axios from "../../../../api/axios";

const initialState = {
    data:[],
    isLoading:null,
    status:null,
}

const token = userObj?.token

export const walletByCustomer = createAsyncThunk(
    'customer/walletByCustomer',
    async ({ startDate, endDate }, {rejectWithValue}) => {
        
        try{
            const response = await axios.get(`Wallets/PaymentHistory?startDate=${startDate}&endDate=${endDate}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            return rejectWithValue(err.response.data.title)
        }
        
    }
)


const walletByCustomerSlice = createSlice({
    name: 'walletByCustomer',
    initialState,
    reducers: {},
    extraReducers:{
        [walletByCustomer.pending]: (state, action) => {
            state.status='pending';
            state.isLoading=true;
        },
        [walletByCustomer.fulfilled]: (state, action) => {
            state.status='success';
            state.isLoading=false;
            state.data = action.payload;
            // localStorage.setItem('user', JSON.stringify(action.payload))
        },
    
        [walletByCustomer.rejected]: (state, action) => {
            state.status='failed';
            state.isLoading=false;
        }
    }
})

export default walletByCustomerSlice.reducer;